import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const AssetGroupTreeServiceConfig = {
  name: "AssetGroupTree",
  annotations: []
} as ServiceConfig;